import { isHiddenAssistantPrompt } from '../AIEntityMentionsInput.utils';
import { useAIChatMessagesContext } from './context';
import Item from './Item';
import { getMessageText } from './utils';

const List = () => {
  const { hideAssistantMessage, hideUserMessage, messages } = useAIChatMessagesContext();
  if (messages.length === 0) return null;

  const visibleMessages = messages.filter((message) => {
    if (message.role === 'assistant' && hideAssistantMessage) return false;
    if (message.role === 'user' && hideUserMessage) return false;
    if (message.role === 'user' && isHiddenAssistantPrompt(getMessageText(message))) return false;
    return true;
  });

  if (visibleMessages.length === 0) return null;

  return visibleMessages.map((message, index) => {
    return <Item key={`${message.id}-${message.role}`} message={message} isLastMessage={index === visibleMessages.length - 1} />;
  });
};

export default List;
